import TabSelection from "../../components/SelectContent/TabSelection";

import { setAdminTab } from "../../state/slices/generalSlice";
import Positions from "./Positions";
import Employees from "./Employees";
import InactiveEmployees from "./InactiveEmployees";
import AllTrl from "./AllTrl";
import CategorizedPosition from "./CategorizedPosition";
import AllCos from "./AllCos";
import AllCwa from "./AllCwa";
import SpectatorAccess from "./SpectatorAccess";

import {
  TeamOutlined,
  ApartmentOutlined,
  AppstoreOutlined,
  EyeOutlined,
  CarFilled,
  CarryOutOutlined,
  FileDoneOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";

function AdminPage() {
  const menuItems = [
    {
      key: "employees",
      label: "Employee Masterlist",
      component: <Employees />,
      icon: <TeamOutlined />,
    },
    {
      key: "inactive-employees",
      label: "Inactive Employees",
      component: <InactiveEmployees />,
      icon: <UserDeleteOutlined />,
    },
    {
      key: "positions",
      label: "Position Masterlist",
      component: <Positions />,
      icon: <ApartmentOutlined />,
    },
    {
      key: "categorized-position",
      label: "Categorized Position",
      component: <CategorizedPosition />,
      icon: <AppstoreOutlined />,
    },
    {
      key: "spectator-access",
      label: "AO Access",
      component: <SpectatorAccess />,
      icon: <EyeOutlined />,
    },
    {
      key: "all-trl",
      label: "All Travel Request Local",
      component: <AllTrl />,
      icon: <CarFilled />,
    },
    {
      key: "all-cos",
      label: "All Certificate of Service",
      component: <AllCos />,
      icon: <CarryOutOutlined />,
    },
    {
      key: "all-cwa",
      label: "All Certificate of Work Accomplishment",
      component: <AllCwa />,
      icon: <FileDoneOutlined />,
    },
  ];
  return (
    <>
      <TabSelection
        menuItems={menuItems}
        currentTabKey="adminCurrentTab"
        setTabAction={setAdminTab}
      />
    </>
  );
}

export default AdminPage;
